import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI } from 'wix-rich-content-common';
import { LoaderIcon } from 'wix-rich-content-plugin-commons';
import { SearchInputModal, FOOTER_BUTTON_ALIGNMENT, MODAL_CONTROLS_POSITION, BUTTON_SIZE } from 'wix-rich-content-ui-components';
import { g as generalStyles, I as ItemsList } from '../ItemsList-fa31729c.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { contentTypeMap } from '../constants.js';
import { convertDuration } from '../convertDuration.js';
import { INSERT_VERTICAL_EMBED_MODAL } from '../dataHooks.js';
import { VERTICAL_EMBED_TYPE } from '../types.js';
import 'classnames';
import './itemsList/Item.js';
import 'wix-rich-content-common/libs/imageUtils';
import 'ricos-schema';
import 'lodash';

var css_248z = "[dir] ._--kSc{padding-top:20px}[dir=ltr] ._--kSc{margin-right:-20px}[dir=rtl] ._--kSc{margin-left:-20px}.YBfW1{animation-duration:1.5s;animation-iteration-count:infinite;animation-name:G-CXI;animation-timing-function:linear}@keyframes G-CXI{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}";
var styles = {"itemsWrapper":"_--kSc","fileLoaderIcon":"YBfW1","spin":"G-CXI"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const LOADING = "LOADING";
const NO_ITEMS = "NO_ITEMS";
const READY = "READY";
const NOT_FOUND = "NOT_FOUND";
class VerticalEmbedInsertModal extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      errorMsg: "",
      items: [],
      status: LOADING
    });
    __publicField(this, "onInputChange", (inputString = "") => {
      this.verticalApi.search(inputString).then((items) => {
        this.setState({ items, status: items.length === 0 ? NOT_FOUND : READY });
      });
      this.setState({ inputString });
    });
    __publicField(this, "onConfirm", () => {
      var _a;
      const { onConfirm, componentData, helpers } = this.props;
      const { selectedProduct } = this.state;
      (_a = helpers == null ? void 0 : helpers.onPluginsPopOverClick) == null ? void 0 : _a.call(helpers, {
        pluginId: VERTICAL_EMBED_TYPE,
        buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.embed
      });
      if (!selectedProduct) {
        return;
      }
      const {
        id,
        imageSrc,
        imageHeight,
        imageWidth,
        name,
        pageUrl,
        scheduling,
        location,
        durations
      } = selectedProduct;
      const additionalData = componentData.type === "BOOKING" ? { bookingData: { durations } } : componentData.type === "EVENT" ? { eventData: { scheduling, location } } : {};
      onConfirm(__spreadValues(__spreadProps(__spreadValues({}, componentData), {
        name,
        itemId: id,
        url: pageUrl,
        image: { src: { url: imageSrc }, height: imageHeight, width: imageWidth }
      }), additionalData));
    });
    __publicField(this, "onItemClick", (_a) => {
      var _b = _a, item = __objRest(_b, ["getDescription"]);
      const { selectedProduct } = this.state;
      if (this.props.isMobile) {
        this.setState({ selectedProduct: item }, this.onConfirm);
      }
      if (item.id === (selectedProduct == null ? void 0 : selectedProduct.id)) {
        this.onConfirm();
      } else {
        this.setState({ selectedProduct: item });
      }
    });
    __publicField(this, "getItems", () => {
      const {
        componentData: { type },
        t
      } = this.props;
      const { items } = this.state;
      let getDescription;
      if (type === "BOOKING") {
        getDescription = (product) => convertDuration(product.durations, t);
      } else if (type === "EVENT") {
        getDescription = (product) => `${product.scheduling} | ${product.location}`;
      }
      return getDescription ? items.map((product) => __spreadProps(__spreadValues({}, product), { getDescription })) : items;
    });
  }
  componentDidMount() {
    const {
      verticalsApi,
      componentData: { type },
      locale
    } = this.props;
    this.verticalApi = verticalsApi(type.toLowerCase(), locale);
    try {
      this.verticalApi.search("").then((items) => {
        this.setState({ items, status: items.length === 0 ? NO_ITEMS : READY });
      });
    } catch (e) {
      console.error("failed to load products ", e);
      this.setState({ items: [], status: NO_ITEMS });
    }
  }
  render() {
    const { inputString, selectedProduct, status } = this.state;
    const {
      t,
      componentData: { type },
      helpers,
      isMobile,
      onCloseRequested,
      showCloseButton
    } = this.props;
    const contentType = contentTypeMap[type];
    const emptyState = /* @__PURE__ */ React.createElement("div", { className: generalStyles.emptyState }, /* @__PURE__ */ React.createElement("div", { className: generalStyles.title }, t(`Embed_Vertical_${contentType}_EmptyState_NoResults_Title`)), /* @__PURE__ */ React.createElement("div", { className: generalStyles.description }, t(`Embed_Vertical_${contentType}_EmptyState_NoResults_Description`)));
    return /* @__PURE__ */ React.createElement(
      SearchInputModal,
      {
        onConfirm: this.onConfirm,
        helpers,
        t,
        title: t(`Embed_Vertical_${contentType}_Title`),
        dataHook: INSERT_VERTICAL_EMBED_MODAL,
        placeholder: t(`Embed_Vertical_${contentType}_Placeholder`),
        saveLabel: t("Embed_Add_Button_Label"),
        onCloseRequested,
        onInputChange: this.onInputChange,
        input: inputString,
        isMobile,
        buttonAlignment: FOOTER_BUTTON_ALIGNMENT.END,
        controlsPosition: isMobile ? MODAL_CONTROLS_POSITION.TOP : MODAL_CONTROLS_POSITION.BOTTOM,
        selected: !!selectedProduct,
        buttonSize: BUTTON_SIZE.small,
        showTitle: !isMobile,
        showCloseButton
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.itemsWrapper }, status === LOADING ? /* @__PURE__ */ React.createElement("div", { className: generalStyles.emptyState }, /* @__PURE__ */ React.createElement(LoaderIcon, { className: styles.fileLoaderIcon })) : status === NOT_FOUND ? emptyState : /* @__PURE__ */ React.createElement(
        ItemsList,
        {
          isMobile,
          selectedItem: selectedProduct,
          items: this.getItems(),
          onClick: this.onItemClick,
          contentType,
          t
        }
      ))
    );
  }
}
VerticalEmbedInsertModal.propTypes = {
  componentData: PropTypes.object.isRequired,
  t: PropTypes.func,
  isMobile: PropTypes.bool,
  verticalsApi: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  experiments: PropTypes.object,
  onCloseRequested: PropTypes.func,
  onConfirm: PropTypes.func,
  helpers: PropTypes.object.isRequired,
  showCloseButton: PropTypes.bool
};

export { VerticalEmbedInsertModal as default };
//# sourceMappingURL=VerticalEmbedInsertModal.js.map
